import { render, staticRenderFns } from "./CustomerStaffList.vue?vue&type=template&id=72bc1102&"
import script from "./CustomerStaffList.vue?vue&type=script&lang=js&"
export * from "./CustomerStaffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports